import React from 'react';
import Icon from '../../../components/AppIcon';

const AutomationTriggersPanel = ({ automationStatus }) => {
  const automations = [
    { 
      name: 'Importação CSV', 
      key: 'csvImport', 
      icon: 'Upload',
      description: 'Processamento automático de arquivos CSV'
    },
    { 
      name: 'Exportação de Produtos', 
      key: 'productExport', 
      icon: 'Download',
      description: 'Geração de arquivos para marketplaces'
    },
    { 
      name: 'Publicação de Campanhas', 
      key: 'campaignPublishing', 
      icon: 'Send',
      description: 'Envio automático para canais de venda'
    }
  ];

  const getStatusColor = (successRate) => {
    if (successRate >= 95) return 'success';
    if (successRate >= 80) return 'warning';
    return 'error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
          <Icon name="Zap" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="font-semibold text-foreground">Automações Ativas</h3>
          <p className="text-xs text-muted-foreground">Workflows e triggers em execução</p>
        </div>
      </div>

      <div className="space-y-3">
        {automations?.map((automation) => {
          const status = automationStatus?.[automation?.key];
          const statusColor = getStatusColor(status?.successRate);

          return (
            <div key={automation?.key} className="p-4 rounded-lg bg-muted/30 space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Icon name={automation?.icon} size={18} className="text-muted-foreground" />
                  <div>
                    <p className="text-sm font-medium text-foreground">{automation?.name}</p>
                    <p className="text-xs text-muted-foreground">{automation?.description}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div 
                    className="w-2 h-2 rounded-full"
                    style={{ backgroundColor: status?.active ? 'var(--color-success)' : 'var(--color-error)' }}
                  />
                  <span className="text-xs font-semibold text-foreground">
                    {status?.active ? 'Ativo' : 'Inativo'}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div className="p-2 rounded bg-background/50">
                  <p className="text-xs text-muted-foreground mb-1">Taxa de Sucesso</p>
                  <div className="flex items-center gap-2">
                    <p 
                      className="text-sm font-semibold"
                      style={{ color: `var(--color-${statusColor})` }}
                    >
                      {status?.successRate || 0}%
                    </p>
                    <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
                      <div 
                        className="h-full transition-smooth"
                        style={{ 
                          width: `${status?.successRate || 0}%`,
                          backgroundColor: `var(--color-${statusColor})`
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="p-2 rounded bg-background/50">
                  <p className="text-xs text-muted-foreground mb-1">Fila</p>
                  <p className="text-sm font-semibold text-foreground">
                    {status?.queueDepth || 0} itens
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AutomationTriggersPanel;